// extracted by mini-css-extract-plugin
export default {"formContainer":"style_formContainer__jQ3oH","btn":"style_btn__sHf1n"};